import { TEtfTransactionType } from '@/services/apis/trade/types';

export const getEtfTransactionOrderSideTitle = (type: TEtfTransactionType) => {
  switch (type) {
    case 'Sell':
      return 'فروش';
    case 'Buy':
    default:
      return 'خرید';
  }
};
